<p-confirmpopup #confirmPopup [key]="key">
  <ng-template pTemplate="headless">
    <div
      class="flex flex-col gap-3 bg-white rounded-md p-6 h-full justify-between">
      <div class="sh2 text-gray-1000">
        {{ header }}
      </div>
      <div class="b1 m-0 text-gray-1000">
        {{ message }}
      </div>
      <div class="flex flex-row justify-end gap-3 saas-ui-size-default">
        @if (rejectVisible) {
          <m-button type="secondary" (click)="onCancel($event)">
            <div class="b2">{{ rejectLabel }}</div>
          </m-button>
        }
        <m-button type="primary" (click)="onSubmit($event)">
          <div class="b2">{{ acceptLabel }}</div>
        </m-button>
      </div>
    </div>
  </ng-template>
</p-confirmpopup>
